import React, { useEffect, useState } from 'react';
import axios from 'axios';


function Eula() {
  const [eula, setEula] = useState('')

  useEffect(() => {
      const getEula = async () => {
        const resp = await axios.get(process.env.REACT_APP_API_URL + 'eula')
        setEula(resp?.data?.eula ? resp.data.eula : '')
      }

      getEula()
  }, [])

  return (
    <div className="doc">
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {eula}
      </div>
    </div>
  );
}

export default Eula
